import { render, staticRenderFns } from "./comment_questions_table.vue?vue&type=template&id=70b2923a&"
import script from "./comment_questions_table.vue?vue&type=script&lang=js&"
export * from "./comment_questions_table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports